import Button from '@material-ui/core/Button'
import React, { useState } from 'react'
import EkomApi from '../../api/EkomApi'
import { useCheckedContext } from '../../context/CheckedContext'
import { TABLE_TYPE, useTableContext } from '../../context/TableContext'
import { toastError, toastSuccess } from '../../customs/Toast/Toast'
import ModalConfirm from '../../parts/ModalConfirm'

interface iTableCheckedActions {
  data: Array<any>,
}

export const TableCheckedActions = ({ data }: iTableCheckedActions) => {

  const { checked, resetChecked, setChecked, addReloadIndex } = useCheckedContext()
  const { type } = useTableContext()

  const clickCheckedAll = () => {
    setChecked(data.map(d => d.id))
  }

  const clickCheckedUn = () => {
    resetChecked()
  }
  const clickCheckedAsRead = () => {
    (type === TABLE_TYPE.IN ? EkomApi.viewBulkMsgIncoming(checked) : EkomApi.viewBulkMsgOutgoing(checked))
      .then(() => {
        toastSuccess('Vybrané zprávy označeny jako přečtené')
        addReloadIndex()
      })
      .catch(() => {
        toastError('Nepodařilo se označit vybrané zprávy jako přečtené')
      })
  }

  const [openModalConfirm, setOpenModalConfirm] = useState(false)

  return (
    <div style={{ display: 'flex', gap: 10 }}>

      <Button variant="outlined" color="primary" size="small" onClick={clickCheckedAll}>Vybrat vše</Button>
      <Button variant="outlined" color="primary" size="small" disabled={!checked.length} onClick={clickCheckedUn}>Zrušit
        výběr {checked.length || ''}</Button>
      <Button variant="outlined" color="primary" size="small" disabled={!checked.length}
              onClick={() => setOpenModalConfirm(true)}>Označit
        vybrané jako přečtené {checked.length || ''}</Button>

      <ModalConfirm
        title={`Opravdu chcete označit zprávy jako přečtené?`}
        text={'V případě hromadného označení zpráv dojde k označení přečtení pouze v eKomunikaci; v souvisejících systémech (elektronických nástrojích) zůstanou nadále jako nepřečtené, jelikož nedošlo k jejich faktickému zobrazení, které může mít pro zadavatele i dodavatele souvisejících zakázek specifický význam, a doporučujeme proto jejich reálné přečtení'}
        open={openModalConfirm}
        setOpen={setOpenModalConfirm}
        onConfirm={clickCheckedAsRead}
        closeOnConfirm
      />

    </div>
  )
}
